import { useLocation } from "react-router-dom";
import { ROUTES } from "@constants";
import { Footer } from "@features/footer/Footer";

const FOOTER_UNABLED_PATH_LIST: readonly string[] = [ROUTES.MOBILE_PAGE_URL, ROUTES.BROADBAND_PAGE_URL];

const SPACER_UNABLED_PATH_LIST: readonly string[] = [
    ROUTES.CART_PAGE_URL,
    ROUTES.DETAILS_PAGE_URL,
    ROUTES.INSTALLATION_PAGE_URL,
    ROUTES.SUMMARY_PAGE_URL,
];

export const AppFooter = () => {
    const { pathname } = useLocation();

    if (SPACER_UNABLED_PATH_LIST.includes(pathname)) {
        return <div style={{ height: "100px" }} />;
    }

    if (FOOTER_UNABLED_PATH_LIST.includes(pathname)) {
        return <Footer />;
    }

    return null;
};
